module.exports = __webpack_public_path__ + "img/NewsCenterDetails6_pic2.95d34725.png";